angular.module('wbDashboard').controller('PlanningStudentRefiControllerAurea', ['$scope', '$timeout', '$uibModal', '$q', '$window', 'PlanningService', 'ThinkingService', 'CommonConstant', 'Message', 'Request', 'Track', function ($scope, $timeout, $uibModal, $q, $window, PlanningService, ThinkingService, CommonConstant, Message, Request, Track) {

    $scope.studentRefi = {
        interest_rate: null,
        timer: null,
        showAnyway: null
    };

    $scope.pageData = {
        sending: false,
        updatingSavings: false,
        showTerm: false,
        thinking: false,
        modalInstance: null,
    };
    $scope.forms = {};

    $scope.options = {
    };

    $scope.recommendationSlug = $scope.$stateParams.recommendationSlug ? $scope.$stateParams.recommendationSlug : PlanningService.partnerInfo.studentRefi.slug;


    $scope.showLoading = function() {
        $scope.pageData.thinking = true;
        ThinkingService.open($scope, "studentrefi", {thinking:"Calculating Estimated Savings", complete:"Complete!"});
    };

    $scope.studentRefiModal = function() {
        $scope.pageData.modalInstance = $uibModal.open({
            templateUrl: 'modal-planning-studentrefi-info.tpl.html',
            scope: $scope,
            size: 'md',
            windowClass:'studentrefi-info-modal partner-info-modal confirm-modal'
        });
        $scope.pageData.modalInstance.result.catch(angular.noop);
    };

    $scope.submitToCommonbond = function() {

        Track.send("Send to Partner", "planning", {partner: "commonbond"});

        $scope.pageData.sending = true;
        PlanningService.completeRecommendation($scope.recommendationSlug).then(function() {
            // angular.element("form[name='forms.studentrefi']").submit();
            $window.location.href = $scope.studentRefi.referral_url;
        });
    };

    $scope.complete = function() {
        $scope.pageData.sending = true;
        PlanningService.completeRecommendation($scope.recommendationSlug).then(function() {
            return PlanningService.retrieveRecommendations(true);
        }).finally(function() {
            $scope.$state.go('base.planning');
        });
    };

    $scope.dismiss = function() {
        $scope.pageData.sending = true;
        PlanningService.dismissRecommendation($scope.recommendationSlug, "Should Not Refinance").then(function() {
            return PlanningService.retrieveRecommendations(true);
        }).finally(function() {
            $scope.$state.go('base.planning');
        });
    };

    $scope.goNextPage = function() {
        switch ($scope.$stateParams.page) {
            case 'difficulty':
                $scope.$state.go('.',{page:'notes'});
                break;
            case 'notes':
                $scope.$state.go('.',{page:'introducing'});
                break;
            case 'adjust':
                $scope.$state.go('.',{page:'introducing'});
                break;
            case 'introducing':
                $scope.$state.go('.',{page:'submit'});
                break;
        }

    };

    init();

    function init() {

        $scope.$watch('studentRefi.interest_rate', function (rate) {
            if (rate) {
                $scope.pageData.updatingSavings = true;

                $timeout.cancel($scope.studentRefi.timer);
                $scope.studentRefi.timer = $timeout(function () {
                    //need to create manual debounce
                    updateSavings(rate);
                }, 750);
            }
        });

        $scope.showLoading();

        $q.all([updateInterest(), updateSavings()]).then(function() {
            $scope.pageData.thinking = false;

            if ($scope.studentRefi.showAnyway) {
                $scope.$state.go(".", {page: "difficulty"}, {location: "replace"});
            } else {
                $scope.$state.go(".", {page: "adjust"}, {location: "replace"});
            }

        }).then(function() {
            ThinkingService.close(false, 'studentrefi');
        });


    }

    function updateInterest() {
        $scope.pageData.sending = true;

        return Request.make('student_refi_interest').then(function(response) {
            var data = response.data;

            $scope.studentRefi.showAnyway = data.show_calculation;

            $scope.studentRefi.monthly_payments = data.monthly_payments;
            $scope.studentRefi.accruing_monthly_interest = data.accruing_monthly_interest;

        }).catch(function() {
        }).finally(function() {
            $scope.pageData.sending = false;
        });

    }

    function updateSavings(rate) {
        $scope.pageData.sending = true;
        $scope.pageData.updatingSavings = true;

        return Request.make('student_refi_savings', {interestRate:rate}).then(function(response) {
            /**
             * @param {Object} data
             * @param {int} data.est_monthly_savings
             * @param {int} data.est_total_savings
             * @param {int} data.interest_rate
             * @param {int} data.max_interest_rate
             * @param {int} data.min_interest_rate
             * @param {string} data.referral_partner
             * @param {string} data.referral_url
             */
            var data = response.data;

            if (!$scope.studentRefi.interest_rate || $scope.studentRefi.interest_rate === data.interest_rate) {
                //in case it was changed since requested
                angular.extend($scope.studentRefi, data);

                //need calculated for ticks on slider
                $scope.studentRefi.interest_rate_33 = PlanningService.round05(($scope.studentRefi.max_interest_rate-$scope.studentRefi.min_interest_rate)*0.33+$scope.studentRefi.min_interest_rate);
                $scope.studentRefi.interest_rate_66 = PlanningService.round05(($scope.studentRefi.max_interest_rate-$scope.studentRefi.min_interest_rate)*0.66+$scope.studentRefi.min_interest_rate);
                $scope.studentRefi.min_interest_rate = PlanningService.round05($scope.studentRefi.min_interest_rate, true);
                $scope.studentRefi.max_interest_rate = PlanningService.round05($scope.studentRefi.max_interest_rate);

            }
        }).catch(function() {
        }).finally(function() {
            $scope.pageData.sending = false;
            $scope.pageData.updatingSavings = false;
        });
    }

    var transitionDeregisterHook;
    transitionDeregisterHook = $scope.$transitions.onBefore({ to: 'base.planning.studentrefi' }, function(trans) {
        if (trans.params('to').page === "submit") {
            //get token?
        }
    });
    $scope.$on('$destroy', function() {
        transitionDeregisterHook();
    });

}]);
